module.exports = __webpack_public_path__ + "img/function06.9e7c6269.png";